import { Information as InformationBase } from './Information'
import { InformationField } from './InformationField'
import { InformationFieldWithTwoImages } from './InformationFieldWithTwoImages'

export type { InformationFieldProps } from './InformationField'

export const Information = Object.assign(InformationBase, {
  InformationField,
  InformationFieldWithTwoImages
})
